module.exports = "<div class=row> <div class=col-xs-12> <app-form-text multiline=true i18n-label=\"Description Summer\" i18n-help=\"Description Summer Help\" field=poi.description_summer main-lang=poi.main_lang></app-form-text> </div> </div> <div class=row> <div class=col-xs-12> <app-form-text multiline=true i18n-label=\"Description Winter\" i18n-help=\"Description Winter Help\" field=poi.description_winter main-lang=poi.main_lang></app-form-text> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/general/partial_descriptions.html
// module id = 433
// module chunks = 0